/* eslint-disable */
import React, { Component } from 'react';
import firebase from 'firebase';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { firebaseConnect, populate } from 'react-redux-firebase';
import { AppNavigation, AppMaster, AppDetail } from 'medua-components';
import FreshChat from 'react-freshchat';
// import { studentApp } from '../store';
// import { ToastContainer, toast } from 'react-toastify';
// import notificationStyle from '../components/elements/notification/notificationStyle';
// import Banner from '../components/elements/notification';

// import { history } from '../store';

const populates = [
  { root: 'schools', child: 'school', keyProp: 'key' },
];
const populateData = [
  { root: 'courses', child: 'courses' },
  { root: 'courses-pending', child: 'courses-pending' },
];

/* eslint-disable */
@connect(
  ({ firebase, firebase: { auth, profile } }) => ({
    auth,
    user: populate(firebase, 'profile', populates),
    schoolKey: profile.school
  }),
)
@firebaseConnect(
  props => [{ path: `schools-data/${props.schoolKey}`, storeAs: 'schooldata' }]
)
@connect(
  ({ firebase, firebase: { data: { schooldata } } }) => ({
    schooldata: populate(firebase, 'schooldata', populateData),
  })
)
@translate(['app', 'help'])
export default class App extends Component {

  constructor(props) {
    super(props)
  }

  componentWillReceiveProps(next) {
    // if (next.account.meta) {
    //   if(next.account.meta.role != 10) {
    //     next.firebase.logout();
    //     // toast.error('User not found.')
    //   }
    // }
    // if (isLoaded(next.user)) {
    //   const ref = studentApp.database().ref('schools-data/' + next.user.school.id );
    //   ref.on('value', snapshot => {
    //     let snap = snapshot.val()
    //     if(snap == null) {
    //       return this.setState({ loading: false })
    //     }
    //     this.setState({ sdata: snap, loading: false })
    //   })
    // }
  }

  componentDidMount() {
    this.removeListener = firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        if (user.emailVerified) {
          this.props.setUser(user);
          firebase.database().ref(`/users/${user.uid}`).once('value').then((snapshot) => {
            if (snapshot.val()) {
              this.props.setUserData(snapshot.val());
            }
          });
        } else {
          // this.props.setNotification({ message: USER_CONFIRM_EMAIL, type: 'info' });
        }
      }
    });
  }

  componentWillUnmount() {
    this.removeListener();
  }

  getLocalTitle() {
    function capitalize(string) {
      return string.charAt(0).toUpperCase() + string.slice(1)
    }
    let title, array = this.props.location.pathname.split("/")
    if (array.length > 3) {
      title = capitalize(array[array.length-2])
    } else {
      title = capitalize(array[array.length-1])
    }
    return title
  }

  render() {
    let { user, user: { requests } } = this.props
    /* eslint-disable no-unused-vars */
    let touch = false;
    if ((window.navigator.userAgent.match(/iPhone/i)) || (window.navigator.userAgent.match(/iPad/i))) {
      touch = true;
    }
    return (
      <div className="app-navigation-left">
        <Helmet
          title={ this.getLocalTitle() != "" ? `${ this.getLocalTitle()} | ${ 'Medua School' }` : 'Medua School' }
          bodyAttributes={{ class: this.props.location.pathname.split("/")[1] }}
        />
        <AppNavigation
          position="left"
          touch={touch}
          toplist={[
            { key: '1', icon: 'logo' },
            { key: '2', icon: 'course', name: this.props.t('app:courses'), url: '/courses' },
            { key: '5', icon: 'help', name: this.props.t('app:feedback'), action: () => window.fcWidget.open() }
          ]}
          bottomlist={[
            { key: '1', icon: 'school', name: this.props.t('app:school'), url: '/school' },
          ]}
        />
        <main className={this.props.detail ? 'split' : ''}>
          <AppMaster>
            { React.cloneElement(this.props.master, { user: this.props.user, auth: this.props.auth, firebase: this.props.firebase, schooldata: this.props.schooldata }) }
          </AppMaster>
          { this.props.detail &&
            <AppDetail>
              { React.cloneElement(this.props.detail, { user: this.props.user, auth: this.props.auth, firebase: this.props.firebase, schooldata: this.props.schooldata }) }
            </AppDetail>
          }
          { this.props.user.meta &&
            <FreshChat
              token="e9ab2331-c32c-40bf-85b4-281bb5ec81c0"
              locale={ this.props.i18n.language }
              tags={["feedback"]}
              config={{
                disableEvents:true,
                headerProperty: {
                  backgroundColor: '#2eb4a4',
                  hideChatButton: true
                },
                content: {
                  placeholders: {
                    search_field: this.props.t('help:content.placeholders.search_field'),
                    reply_field: this.props.t('help:content.placeholders.reply_field'),
                  },
                  actions: {
                    csat_yes: this.props.t('help:content.actions.csat_yes'),
                    csat_no: this.props.t('help:content.actions.csat_no'),
                    push_notify_yes: this.props.t('help:content.actions.push_notify_yes'),
                    push_notify_no: this.props.t('help:content.actions.push_notify_no'),
                    tab_faq: this.props.t('help:content.actions.tab_faq'),
                    tab_chat: this.props.t('help:content.actions.tab_chat'),
                    csat_submit: this.props.t('help:content.actions.csat_submit')
                  },
                  headers: {
                    chat: this.props.t('help:content.headers.chat'),
                    faq: this.props.t('help:content.headers.faq'),
                    faq_help: this.props.t('help:content.headers.faq_help'),
                    faq_not_available: this.props.t('help:content.headers.faq_not_available'),
                    faq_search_not_available: this.props.t('help:content.headers.faq_search_not_available', { query: '{{query}}' }),
                    faq_useful: this.props.t('help:content.headers.faq_useful'),
                    faq_thankyou: this.props.t('help:content.headers.faq_thankyou'),
                    faq_message_us: this.props.t('help:content.headers.faq_message_us'),
                    push_notification: this.props.t('help:content.headers.push_notification'),
                    csat_question: this.props.t('help:content.headers.csat_question'),
                    csat_yes_question: this.props.t('help:content.headers.csat_yes_question'),
                    csat_no_question: this.props.t('help:content.headers.csat_no_question'),
                    csat_thankyou: this.props.t('help:content.headers.csat_thankyou'),
                    csat_rate_here: this.props.t('help:content.headers.csat_rate_here'),
                    channel_response: {
                      offline: this.props.t('help:content.headers.channel_response.offline'),
                      online: {
                        minutes: {
                          one: this.props.t('help:content.headers.channel_response.online.minutes.one'),
                          more: this.props.t('help:content.headers.channel_response.online.minutes.more', { time: '{{time}}' })
                        },
                        hours: {
                          one: this.props.t('help:content.headers.channel_response.online.hours.one'),
                          more: this.props.t('help:content.headers.channel_response.online.hours.more', { time: '{{time}}' })
                        }
                      }
                    }
                  }
                }
              }}
              externalId={this.props.auth.uid}
              email={this.props.auth.email}
              restoreId={this.props.user.settings.support_token}
              phone=""
              onInit={widget => {
                  widget.user.setProperties({
                    email: this.props.auth.email,
                  })
                  widget.on('user:created', resp => {
                    var status = resp && resp.status,
                        data = resp && resp.data;
                    if (status === 200) {
                      console.log(data);
                      if (data.restoreId && data.resoreId != this.props.user.settings.support_token) {
                        this.props.firebase.update(
                          `users/${this.props.auth.uid}/settings`, {
                            support_token: data.restoreId
                        })
                      }
                    }
                  })
              }}
            />
          }
        </main>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/app.jsx